<script>
import { cloneDeep, groupBy } from "lodash";
import Swal from "sweetalert2";
import RawData from "@/components/widgets/raw-data.vue";
import { required } from "vuelidate/lib/validators";
export default {
    name: 'posted-opcr',
    components: {
        RawData,
    },
    props: {
        campusTemplates: Array,
        busy: Boolean,
        withLib: {
            type: Boolean,
            default: false,
        },
        withStatusSelection: {
            type: Boolean,
            default: false,
        }
    },
    computed: {
        filtered() {
            let data = this.campusTemplates;
            var total = this.currentPage * this.perPage;
            if (this.filterDUs.trim() != "" && this.filterDUs) {
                data = data.filter((item) => {
                return item.deliveryUnit.name
                    .toUpperCase()
                    .includes(this.filterDUs.toUpperCase());
                });
            }
            var currentData = data.slice(total - this.perPage, total);
            if (this.currentPage > 1 && currentData.length == 0) {
                total = (this.currentPage - 1) * this.perPage;
                currentData = data.slice(total - this.perPage, total);
            }
            return currentData;
        },
        filteredOPCR() {
            let data = this.opcrs;
            if (this.searchOPCR.trim() != "" && this.searchOPCR) {
                data = data.filter((item) => {
                return item.title
                    .toUpperCase()
                    .includes(this.searchOPCR.toUpperCase());
                });
            }
            return data;
        },
        rows(){
            let data = this.campusTemplates;
            if (this.filterDUs.trim() != "" && this.filterDUs) {
                data = data.filter((item) => {
                    return item.deliveryUnit.name
                        .toUpperCase()
                        .includes(this.filterDUs.toUpperCase());
                });
            }
            return data.length;
        }
    },
    data () {
        return {
            filterDUs: '',
            selectedDU: null,
            searchOPCR: '',
            opcrs: [],
            selectedOPCR: null,
            returnForm: {
                id: 0,
                remarks: '',
            },
            submitted: false,
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 25, 50, 100],
            statusSelection: 'Pending',
            tabOptions: [
                "Strategic Priority",
                "Core Functions",
                "Mandatory Support Function",
            ],
        }
    },
    validations: {
        returnForm: {
            remarks: {
                required,
            },
        },
    },
    methods: {
        viewOPCRs(row){
            this.searchOPCR = '';
            this.selectedDU = row;
            row.opcrs.forEach((item) => {
                item.tabIndex = 0;
                item.searchTarget = '';
                item.tabSelect = "Strategic Priority";
            });
            this.opcrs = cloneDeep(row.opcrs);
        },
        
        async getTags(target) {
            target.tags = [];
            await this.$store
                .dispatch("planningtarget/GetTagsByTarget", target.id)
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    target.tags = res.data;
                })
                .catch((err) => {
                    this.showToast("Something went wrong!", "error");
                });
        },
        async viewTargets(row){
            row.showLibs = false;
            row.showTargets = !row.showTargets;
            if(row.showTargets && row.targets.length == 0){
                row.loadTarget = true;
                await this.getTargets(row);
                for await (const item of row.targets) {
                    await this.getTags(item);
                }
                row.loadTarget = false;
            }
        },
        deleteTag(row, parent) {
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, remove it!",
            }).then((result) => {
                if (result.value) {
                this.$store
                    .dispatch("planningtarget/RemoveTags", row.id)
                    .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                        let index = parent.tags.findIndex((x) => x.id == row.id);
                        parent.tags.splice(index, 1);
                        this.showToast("Successfully removed!", "success");
                    })
                    .catch((err) => {
                        this.showToast("Something went wrong!", "error");
                    });
                }
            });
        },
        async getTargets(row){
            await this.$store
                .dispatch("planningtarget/GetTargetByOPCR", row.id)
                .then((res) => {
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage, "error")
                    }
                    res.data.map(item => {
                        item.rotateChevy = false;
                        item.apiLoading = false;
                        item.apiList = [];
                        item.tags = [];
                    })
                    row.targets = res.data;
                })
                .catch((err) => {
                    this.showToast("Something went wrong!", "error")
                });
        },
        filteredTargets(props) {
            let data = props.targets;
            if (props.searchTarget.trim() != "" && props.searchTarget) {
                data = data.filter((item) => {
                return item.description
                    .toUpperCase()
                    .includes(props.searchTarget.toUpperCase());
                });
            }
            data = data.filter((item) => {
                if (props.tabSelect == "Strategic Priority")
                return item.planningMainTarget.indicatorItem.indicatorItemClassification.classification
                    .toUpperCase()
                    .includes("STRATEGIC");
                else if (props.tabSelect == "Core Functions")
                return item.planningMainTarget.indicatorItem.indicatorItemClassification.classification
                    .toUpperCase()
                    .includes("CORE");
                else if (props.tabSelect == "Mandatory Support Function")
                return item.planningMainTarget.indicatorItem.indicatorItemClassification.classification
                    .toUpperCase()
                    .includes("MANDATORY");
                else return item;
            });
            return data;
        },
        async getApiList(x, y) {
            y.rotateChevy = !y.rotateChevy;
            if (y.apiList.length == 0 && y.rotateChevy) {
                y.apiLoading = true;
                await this.$store
                    .dispatch("planningapi/GetPlanningApisByTargetAndOPCR", { preplanningTargetId: y.id, preOPCRId: x.id })
                    .then((res) => {
                        if(res.data.error){
                            return this.showToast(res.data.errorMessage, 'error')
                        }
                        res.data.forEach((x) => {
                            x.viewResource = false;
                            x.resourceList = [];
                            x.resourceLoading = false;
                        });
                        y.apiList = res.data;
                    })
                    .catch(() => {
                        this.showToast("Something went wrong!", "error");
                    });
                y.apiLoading = false;
            }
        },
        async getResource(y) {
            y.viewResource = !y.viewResource;
            if (y.resourceList.length == 0 && y.viewResource) {
                y.resourceLoading = true;
                await this.$store
                    .dispatch(
                        "planningapiresource/GetPlanningApiResourcesByApi",
                        y.id
                    )
                    .then((res) => {
                        if(res.data.error){
                            return this.showToast(res.data.errorMessage, 'error')
                        }
                        res.data.map((x) => {
                            x.totalQuantity = 0;
                            x.planningApiResourceDetails.forEach((z) => {
                                x.totalQuantity += z.quantity;
                            });
                        });
                        y.resourceList = res.data;
                    })
                    .catch((err) => {
                        this.showToast("Something went wrong!", "error");
                    });
                y.resourceLoading = false;
            }
        },
        returnOPCR(row){
            this.$emit('return-opcr', row)
        },
        approveOPCR(opcr){
            Swal.fire({
                title: "Are you sure?",
                text: "You want to approve this OPCR?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Yes, approve it!",
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$store
                        .dispatch("preopcr/ApprovePlanningOPCR", opcr.id)
                        .then(async (res) => {
                            if (res.data.error) {
                                return this.showToast(res.data.errorMessage, "error");
                            }
                            this.removeOPCR(opcr.id)
                        })
                        .catch((err) => {
                            this.showToast("Something went wrong!", "error");
                        });
                }
            });
        },
        approveAdminOPCR(opcr){
            Swal.fire({
                title: "Are you sure?",
                text: "You want to approve this OPCR?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Yes, approve it!",
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$store
                        .dispatch("preopcr/ApproveOPCR", opcr.id)
                        .then(async (res) => {
                            if (res.data.error) {
                                return this.showToast(res.data.errorMessage, "error");
                            }
                            this.removeOPCR(opcr.id)
                        })
                        .catch((err) => {
                            this.showToast("Something went wrong!", "error");
                        });
                }
            });
        },
        printPPMPAPI(id){
            this.$emit('print-ppmp-api', id)
        },
        removeOPCR(id){
            let index = this.opcrs.findIndex(x => x.id == id);
            this.opcrs.splice(index, 1);
            let duIndex = this.selectedDU.opcrs.findIndex(x => x.id == id);
            this.selectedDU.opcrs.splice(duIndex, 1);
            this.selectedDU.count--;
            if(this.selectedDU.count == 0){
                this.selectedDU = null;
            }
        },
        async viewLibs(row){
            row.showLibs = !row.showLibs;
            row.showTargets = false;
            if(row.showLibs && row.libs.length == 0){
                row.loadLib = true;
                await this.getLibs(row);
                row.loadLib = false;
            }
        },
        async getLibs(y){
            await this.$store
                .dispatch("financeTemplate/getBudgetItemByOPCR", y.id)
                .then((res) => {
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage, 'error')
                    }
                    res.data.forEach((item) => {
                        item.fundClass =
                            item.financeTemplateObjectOfExpenditure.accountGroup.fundClassification.classification;
                        item.fundSource =
                            item.financeTemplateObjectOfExpenditure.financeTemplate.fundSource.sourceName;
                        item.accountGroup =
                            item.financeTemplateObjectOfExpenditure.accountGroup.groupName;
                    });
                    var groupedFS = groupBy(res.data, "fundSource");
                    var grouped = [];
                    var id = 1;
                    var FCID = 1;
                    for (const key in groupedFS) {
                        var sumBalance = 0;
                        var sumAllocated = 0;
                        groupedFS[key].forEach((a) => {
                            sumBalance += a.balance;
                            sumAllocated += a.amount;
                        });
                        var group = groupBy(groupedFS[key], "fundClass");
                        var FC = [];
                        for (const y in group) {
                            FC.push({
                                id: FCID++,
                                data: group[y],
                                key: y,
                            });
                        }
                        grouped.push({
                            id: id++,
                            fsName: key,
                            data: FC,
                            balance: sumBalance,
                            allocated: sumAllocated,
                            fsId: FC[0].data[0]
                                .financeTemplateObjectOfExpenditure.financeTemplate
                                .fundSourceId,
                            financeTemplateId:
                                FC[0].data[0].financeTemplateObjectOfExpenditure
                                    .financeTemplateId,
                        });
                    }
                    y.libs = grouped;
                })
                .catch(() => {
                    this.showToast("Something went wrong!", "error");
                });
        },
        changeStatus($event){
            this.$emit('change-status', $event);
        },
        postOPCR(opcr){
            Swal.fire({
                title: "Are you sure?",
                text: "You want to post this OPCR?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Yes, post it!",
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$store
                        .dispatch("preopcr/ImportOPCR", opcr.id)
                        .then(async (res) => {
                            if (res.data.error) {
                                return this.showToast(res.data.errorMessage, "error");
                            }
                            opcr.imported = true;
                            this.showToast("OPCR successfully posted!", "success");
                        })
                        .catch((err) => {
                            this.showToast("Something went wrong!", "error");
                        });
                }
            });
        },
        printOPCR(opcr, type){
            this.$emit('print-opcr', { id: opcr.id, type })
        },
        printTPMS(opcr){
            this.$emit('print-tpms', opcr.id)
        },
        getPerformanceRating(row) {
            this.$emit("getPerformanceRating", row);
        },
        viewLogs(row) {
            this.$emit("viewLogs", row);
        },
    }
}
</script>
<template>
    <div>
        <div v-if="!selectedDU">
            <div class="d-flex align-items-center justify-content-between">
                <div id="tickets-table_filter" class="dataTables_filter me-1">
                    <label class="d-inline-flex align-items-center mb-0">
                        <b-form-input
                            autocomplete="off"
                            v-model.lazy="filterDUs"
                            type="search"
                            placeholder="Search Delivery Unit..."
                            class="form-control"
                            style="width:250px;"
                        ></b-form-input>
                        <b-form-select
                            class="form-select mx-1"
                            v-model="perPage"
                            size="sm"
                            :options="pageOptions"
                            style="width:70px;"
                        ></b-form-select>
                    </label>
                </div>
                <div>
                    <b-form-select
                        @change="changeStatus"
                        class="form-select mx-1 text-green"
                        v-model="statusSelection"
                        size="sm"
                        :options="['Pending', 'Approved']"
                        v-if="withStatusSelection"
                    ></b-form-select>
                </div>
            </div>
            <div class="my-3">
                <div v-if="busy">
                    <h3>Loading...</h3>
                </div>
                <div v-if="campusTemplates.length == 0 && !busy">
                    <h3>No data found...</h3>
                </div>
                <div v-if="campusTemplates.length && filtered.length == 0">
                    <h3>Search not found</h3>
                </div>
                <div v-if="campusTemplates.length">
                    <div
                        role="tablist"
                        v-for="x in filtered"
                        :key="x.id"
                    >
                        <b-card
                            no-body
                            class="mb-2 shadow-none"
                        >
                            <b-card-header
                                header-tag="header"
                                role="tab"
                                header-class="cursor-pointer"
                                @click="viewOPCRs(x)"
                            >
                                <div
                                    class="
                                        d-flex
                                        justify-content-between
                                        align-items-center
                                    "
                                >
                                    <h6 class="m-0">
                                        <a class="text-dark py-2" href="javascript: void(0);">
                                            &nbsp;
                                            <p class="text-info font-size-16" :class="{'mb-2': x.deliveryUnit.signatory, 'mb-0': !x.deliveryUnit.signatory}">{{ x.deliveryUnit.name }} [{{x.count}}]</p>
                                            <div v-if="x.deliveryUnit.signatory">
                                                <span class="text-white">{{x.deliveryUnit.signatory}} {{` (${x.deliveryUnit.position})`}}</span>
                                            </div>
                                        </a>
                                    </h6>
                                    <div
                                        class="
                                            d-flex
                                            align-items-center
                                        "
                                    >
                                        <div>
                                            <span
                                                class="
                                                    d-flex
                                                    align-items-center
                                                    text-truncate
                                                "
                                                >
                                                <small v-if="!x.rotateChevy">Click to view OPCRs</small
                                            >
                                                <i  class="bx bx-chevron-right rotate font-size-18 ms-3"></i>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </b-card-header>
                        </b-card>
                    </div>
                    <div class="row mt-3">
                        <div class="col">
                            <div
                                class="
                                    dataTables_paginate
                                    paging_simple_numbers
                                    float-end
                                    mb-0
                                "
                            >
                                <ul
                                    class="
                                        pagination pagination-rounded
                                        mb-0
                                    "
                                >
                                    <!-- pagination -->
                                    <b-pagination
                                        v-model="currentPage"
                                        :total-rows="rows"
                                        :per-page="perPage"
                                    ></b-pagination>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else>
            <div class="row my-2">
                <div class="col-sm-12 col-md-4">
                    <h4 class="card-title mb-3 d-flex align-items-center"><a href="javascript:void(0);" @click="selectedDU = null;" class="font-size-20 font-weight-bold me-2"><i class="bx bx-arrow-back"></i></a>{{selectedDU.deliveryUnit.name}}'s OPCR(s)</h4>
                </div>
                <div class="col-sm-12 col-md-8">
                    <div
                        id="tickets-table_filter"
                        class="
                            dataTables_filter
                            text-md-end
                        "
                    >
                        <label
                            class="
                                d-inline-flex
                                align-items-center
                                mb-0
                            "
                        >
                            <b-form-input
                                autocomplete="off"
                                v-model="searchOPCR"
                                type="search"
                                placeholder="Search OPCR..."
                                class="
                                    form-control
                                    form-control-sm
                                    mx-2
                                "
                            ></b-form-input>
                        </label>
                    </div>
                </div>
            </div>
            <div
                role="tablist"
                v-for="(opcr, opcrIndex) in filteredOPCR"
                :key="opcr.id"
            >
                <b-card
                    no-body
                    class="mb-2"
                    :style="{ 'z-index': filteredOPCR.length - opcrIndex }"
                >
                    <b-card-header
                        header-tag="header"
                        role="tab"
                        header-class="px-0"
                    >
                        <div class="d-flex justify-content-between px-3">
                            <div>
                                <div class="font-size-16 mb-1">
                                    {{opcr.title}} 
                                    <span 
                                        class="font-weight-bold text-green" 
                                        v-if="opcr.imported"
                                        >
                                        [Posted]
                                    </span>
                                </div>
                                <div class="d-flex align-items-center">
                                    <a href="javascript:void(0);" class="text-green d-flex align-items-center gap-1" @click="viewTargets(opcr)">{{opcr.showTargets ? 'Hide' : 'Show'}} Target(s) <i class="bx rotate bx-chevrons-right" :class="{'rotate-90': opcr.showTargets}"></i></a> 
                                    <span class="mx-2" v-if="withLib" >|</span>
                                    <a  v-if="withLib" href="javascript:void(0);" class="text-pink d-flex align-items-center gap-1" @click="viewLibs(opcr)">{{opcr.showLibs ? 'Hide' : 'Show'}} LIB(s) <i class="bx rotate bx-chevrons-right" :class="{'rotate-90': opcr.showLibs}"></i></a> 
                                </div>
                            </div>
                            <div v-if="!withLib && (!opcr.planningStatus || opcr.planningStatus.includes('RETURN'))" class="d-flex align-items-center">
                                <div class=" me-2">
                                    <button type="button" class="btn btn-sm btn-secondary me-2" @click="viewLogs(opcr)"><i class="bx bx-receipt"></i> View Logs</button>
                                    <button :id="`withoutLib-popover-${opcr.id}`" tabindex="0" type="button" class="btn btn-sm btn-purple"><i class="bx bx-printer"></i> Reports</button>
                                    <b-popover
                                        :target="`withoutLib-popover-${opcr.id}`"
                                        triggers="click blur"
                                        placement="leftbottom"
                                        variant="secondary"
                                        custom-class="p-0"
                                        >
                                        <b-list-group class="w-100 fit">
                                            <b-list-group-item
                                                button
                                                action
                                                class="d-flex align-items-center"
                                                @click="printOPCR(opcr, 4)"
                                            >OPCR (for PMT)
                                            </b-list-group-item>
                                            <b-list-group-item
                                                button
                                                action
                                                class="d-flex align-items-center"
                                                @click="printOPCR(opcr, 3)"
                                            >OPCR v3
                                            </b-list-group-item>
                                            <b-list-group-item
                                                button
                                                action
                                                class="d-flex align-items-center"
                                                @click="printOPCR(opcr, 2)"
                                            >OPCR v2
                                            </b-list-group-item>
                                            <b-list-group-item
                                                button
                                                action
                                                class="d-flex align-items-center"
                                                @click="printOPCR(opcr, 1)"
                                            >OPCR
                                            </b-list-group-item
                                            >
                                                <b-list-group-item
                                                button
                                                action
                                                class="d-flex align-items-center"
                                                @click="printTPMS(opcr)"
                                            >TPMS
                                            </b-list-group-item
                                            >
                                        </b-list-group>
                                    </b-popover>
                                </div>
                                <!-- <button type="button" class="btn btn-sm btn-purple me-2" @click="printOPCR(opcr)"><i class="bx bx-printer"></i> Print OPCR</button> -->
                                <button type="button" class="btn btn-sm btn-warning me-2" @click="returnOPCR(opcr)"><i class="bx bx-chevrons-left"></i> Return OPCR</button>
                                <button type="button" class="btn btn-sm btn-success" @click="approveOPCR(opcr)"><i class="bx bx-check"></i> Approve OPCR</button>
                            </div>
                            <div v-if="!withLib && opcr.planningStatus && opcr.planningStatus.toUpperCase().includes('APPROVED') && opcr.status.toUpperCase().includes('POSTED')" class="d-flex align-items-center">
                                <button type="button" class="btn btn-sm btn-warning me-2" @click="returnOPCR(opcr)"><i class="bx bx-chevrons-left"></i> Revert OPCR</button>
                            </div>
                            <div v-if="withLib" class="d-flex align-items-center">
                                <div class=" me-2">
                                    <button type="button" class="btn btn-sm btn-secondary me-2" @click="viewLogs(opcr)"><i class="bx bx-receipt"></i> View Logs</button>
                                    <button :id="`withLib-popover-${opcr.id}`" tabindex="0" type="button" class="btn btn-sm btn-purple"><i class="bx bx-printer"></i> Reports</button>
                                    <b-popover
                                    :target="`withLib-popover-${opcr.id}`"
                                    triggers="click blur"
                                    placement="leftbottom"
                                    variant="secondary"
                                    custom-class="p-0"
                                    >
                                    <b-list-group class="w-100 fit">
                                        <b-list-group-item
                                            button
                                            action
                                            class="d-flex align-items-center"
                                            @click="printOPCR(opcr, 4)"
                                        >OPCR (for PMT)
                                        </b-list-group-item>
                                        <b-list-group-item
                                            button
                                            action
                                            class="d-flex align-items-center"
                                            @click="printOPCR(opcr, 3)"
                                        >OPCR v3
                                        </b-list-group-item>
                                        <b-list-group-item
                                            button
                                            action
                                            class="d-flex align-items-center"
                                            @click="printOPCR(opcr, 2)"
                                        >OPCR v2
                                        </b-list-group-item>
                                        <b-list-group-item
                                            button
                                            action
                                            class="d-flex align-items-center"
                                            @click="printOPCR(opcr, 1)"
                                        >OPCR
                                        </b-list-group-item>
                                        <b-list-group-item
                                            button
                                            action
                                            class="d-flex align-items-center"
                                            @click="printTPMS(opcr)"
                                        >TPMS
                                        </b-list-group-item>
                                    </b-list-group>
                                    </b-popover>
                                </div>
                                <!-- <button type="button" class="btn btn-sm btn-purple me-2" @click="printOPCR(opcr)"><i class="bx bx-printer"></i> Print OPCR</button> -->
                                <button type="button" v-if="!opcr.imported" class="btn btn-sm btn-warning me-2" @click="returnOPCR(opcr)"><i class="bx bx-chevrons-left"></i> Return OPCR</button>
                                <button type="button" v-if="!opcr.imported && opcr.status.toUpperCase().includes('POST')" class="btn btn-sm btn-success" @click="approveAdminOPCR(opcr)"><i class="bx bx-check"></i> Approve OPCR</button>
                                <button type="button" v-if="!opcr.imported && opcr.status.toUpperCase().includes('APPROVE')" class="btn btn-sm btn-success" @click="postOPCR(opcr)"><i class="bx bx-check"></i> Post OPCR</button>
                            </div>
                        </div>
                    </b-card-header>
                </b-card>
                <b-collapse
                    :visible="opcr.showTargets"
                    :accordion="`opcr-${opcr.id}`"
                    role="tabpanel"
                >
                    <div v-if="opcr.showTargets" class="table-responsive py-3">
                        <div class="mb-3 d-flex justify-content-end">
                            <div class="w-300px ">
                                <input 
                                    class="form form-control" 
                                    type="text"
                                    placeholder="Search Target"
                                    v-model="opcr.searchTarget"
                                />
                            </div>
                        </div>
                        <b-tabs
                            content-class="text-muted"
                            v-model="opcr.tabIndex"
                            pills vertical
                        >
                            <b-tab
                                v-for="(type, index) in tabOptions"
                                :key="index"
                                @click="opcr.tabSelect = type;"
                            >
                                <template v-slot:title>
                                    <span class="d-inline-block d-sm-none">
                                        <i class="mdi mdi-clock-time-four-outline"></i>
                                    </span>
                                    <span class="d-none d-sm-inline-block">{{ type }}</span>
                                </template>
                                <div>
                                    <template v-if="opcr.loadTarget">
                                        <h4 class="my-1">Loading...</h4>
                                    </template>
                                    <template v-else-if="!filteredTargets(opcr).length">
                                        <h4 class="my-1">No data found.</h4>
                                    </template>
                                    <template v-else>
                                        <div
                                            class="card mb-1"
                                            v-for="(target, targetIndex) in filteredTargets(opcr)"
                                            :key="`target-${opcr.id}-${target.id}`"
                                            :style="{
                                                'z-index': filteredTargets(opcr).length + 10 - targetIndex,
                                            }"
                                        >
                                            <b-card-header>
                                                <div class="d-flex justify-content-between">
                                                    <div class="d-flex align-items-center">
                                                        <div
                                                            class="bg-success bg-gradient text-center me-2 py-1 position-relative"
                                                            style="min-width: 30px"
                                                        >
                                                        <h3 class="mb-0 position-relative"> {{ targetIndex + 1 }} </h3>
                                                        </div>
                                                        <div>
                                                            <div class="d-flex align-items-center">
                                                                <h5 class="card-title font-size-16 mb-0 mt-1 me-1 text-info">{{ target.description }}</h5>
                                                            </div>
                                                            <!-- <div>{{ y.planningMainTarget.indicatorItem.indicatorItemName }}</div> -->
                                                            <div v-if="target.tags.length">
                                                                <b class="me-1">Tags: </b>
                                                                <div class="d-inline">
                                                                    <span
                                                                        class="badge bg-success me-1 font-size-14"
                                                                        v-for="z in target.tags"
                                                                        :key="z.id"
                                                                        :title="z.tag"
                                                                    >
                                                                        {{ z.tag }}
                                                                        <span
                                                                            class="ms-3 cursor-pointer"
                                                                            @click="deleteTag(z, target)"
                                                                        >
                                                                            <i class="bx bx-x-circle text-danger"></i>
                                                                        </span>
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            <div class="d-flex align-items-center gap-2">
                                                                <div>
                                                                    <small>
                                                                        <a
                                                                            href="javascript: void(0);"
                                                                            class="text-warning d-flex align-items-center"
                                                                            @click="getApiList(opcr, target)"
                                                                        >
                                                                            View API's
                                                                        </a>
                                                                    </small>
                                                                </div>
                                                                |
                                                                <div>
                                                                    <small>
                                                                        <a
                                                                            href="javascript: void(0);"
                                                                            class="text-pink d-flex align-items-center"
                                                                            @click="getPerformanceRating(target)"
                                                                            >
                                                                            View Performance
                                                                            Rubric
                                                                        </a>
                                                                    </small>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="d-flex">
                                                        <table class="table mb-0 table-bordered">
                                                            <tr>
                                                                <th
                                                                    style="width: 150px"
                                                                    class="text-center"
                                                                >
                                                                    Cascaded Target
                                                                </th>
                                                                <th style="width: 70px" class="text-center">
                                                                    Q1
                                                                </th>
                                                                <th style="width: 70px" class="text-center">
                                                                    Q2
                                                                </th>
                                                                <th style="width: 70px" class="text-center">
                                                                    Q3
                                                                </th>
                                                                <th style="width: 70px" class="text-center">
                                                                    Q4
                                                                </th>
                                                            </tr>
                                                            <tr>
                                                                <td class="text-center p-0 text-warning">
                                                                {{
                                                                    target.planningMainTarget.isPercentage
                                                                    ? `${target.cascadedTarget}%`
                                                                    : target.cascadedTarget
                                                                }}
                                                                </td>
                                                                <td class="text-center p-0 text-warning">
                                                                {{
                                                                    target.planningMainTarget.isPercentage
                                                                    ? `${target.q1}%`
                                                                    : target.q1
                                                                }}
                                                                </td>
                                                                <td class="text-center p-0 text-warning">
                                                                {{
                                                                    target.planningMainTarget.isPercentage
                                                                    ? `${target.q2}%`
                                                                    : target.q2
                                                                }}
                                                                </td>
                                                                <td class="text-center p-0 text-warning">
                                                                {{
                                                                    target.planningMainTarget.isPercentage
                                                                    ? `${target.q3}%`
                                                                    : target.q3
                                                                }}
                                                                </td>
                                                                <td class="text-center p-0 text-warning">
                                                                {{
                                                                    target.planningMainTarget.isPercentage
                                                                    ? `${target.q4}%`
                                                                    : target.q4
                                                                }}
                                                                </td>
                                                            </tr>
                                                        </table>
                                                    </div>
                                                </div>
                                                <div v-if="target.rotateChevy">
                                                    <hr />
                                                    <div class="d-flex justify-content-between align-items-center">
                                                        <h5>List of API's</h5>
                                                        <a
                                                            href="javascript:void(0);"
                                                            class="font-size-20 text-white"
                                                            @click="target.rotateChevy = false"
                                                        >
                                                            <i class="bx bx-x"></i>
                                                        </a>
                                                    </div>
                                                    <div
                                                        class="text-center"
                                                        v-if="!target.apiLoading && target.apiList.length == 0"
                                                    >
                                                        <h5>No API(s) found</h5>
                                                    </div>
                                                    <div class="text-center" v-if="target.apiLoading">
                                                        <h5>Loading....</h5>
                                                    </div>
                                                    <div
                                                        class="row"
                                                        v-if="!target.apiLoading && target.apiList.length"
                                                    >
                                                        <div class="col-md-12">
                                                        <table class="table table-bordered">
                                                            <thead>
                                                            <tr>
                                                                <th>API Description</th>
                                                                <th width="220px">Total Resources</th>
                                                                <th width="90px" class="text-center">
                                                                Action
                                                                </th>
                                                            </tr>
                                                            </thead>
                                                            <tbody>
                                                            <template v-for="api in target.apiList">
                                                                <tr
                                                                :key="`apiList-z${api.id}-y${target.id}-w${opcr.id}`"
                                                                >
                                                                <td>
                                                                    <div>
                                                                    <a
                                                                        href="javascript:void(0);"
                                                                        class="text-white"
                                                                        @click="getResource(api)"
                                                                        >{{ api.name }}</a
                                                                    >
                                                                    </div>
                                                                    <div>
                                                                    <small
                                                                        class="text-warning cursor-pointer"
                                                                        @click="getResource(api)"
                                                                        >View Resources</small
                                                                    >
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    {{ formatCurrency(api.total) }}
                                                                </td>
                                                                <td class="align-middle">
                                                                    <div
                                                                        class="d-flex justify-content-center"
                                                                    >
                                                                    <button
                                                                        type="button"
                                                                        @click="printPPMPAPI(api.id)"
                                                                        class="btn btn-clear px-1"
                                                                        title="Print PPMP"
                                                                    >
                                                                        <i
                                                                        class="bx bx-printer text-purple font-size-18"
                                                                        ></i>
                                                                    </button>
                                                                    </div>
                                                                </td>
                                                                </tr>
                                                                <tr
                                                                    v-if="api.viewResource"
                                                                    :key="`apiListRrs-z${api.id}-y${target.id}-w${opcr.id}`"
                                                                >
                                                                <td
                                                                    colspan="4"
                                                                    v-if="
                                                                        !api.resourceLoading &&
                                                                        api.resourceList.length == 0
                                                                    "
                                                                    class="broken-border text-center"
                                                                >
                                                                    No data found
                                                                </td>
                                                                <td
                                                                    colspan="4"
                                                                    v-if="api.resourceLoading"
                                                                    class="broken-border text-center"
                                                                >
                                                                    Loading...
                                                                </td>
                                                                <td
                                                                    colspan="4"
                                                                    v-if="!api.resourceLoading && api.resourceList.length"
                                                                >
                                                                    <div
                                                                        v-for="apiResource in api.resourceList"
                                                                        :key="`resourceList-z${api.id}-y${target.id}-w${opcr.id}-a${apiResource.id}`"
                                                                        class="ms-3 mb-1 p-3 broken-border position-relative"
                                                                    >
                                                                        <RawData :data="apiResource" :keyId="`resourceList-z${api.id}-y${target.id}-w${opcr.id}-a${apiResource.id}`" v-if="$store.state.decrypt.isAdmin()"/>
                                                                        <div class="d-flex align-items-center justify-content-between">
                                                                            <div class="d-flex align-items-center">
                                                                                <div class="font-size-20 text-yellow">
                                                                                    {{ apiResource.totalQuantity }} {{apiResource.unit.unitName}}
                                                                                </div>
                                                                                <i class="bx bx-x font-size-20 me-2 text-yellow"></i>
                                                                                <div>
                                                                                    <div>
                                                                                        {{ apiResource.itemName }}
                                                                                        <div>
                                                                                            <small>{{ apiResource.description}}</small>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div class="d-flex align-items-center mb-1">
                                                                                        <span class="badge bg-secondary text-white py-1 px-2 me-2">
                                                                                            {{  apiResource.financeTemplateBudgetItem.financeTemplateObjectOfExpenditure.financeTemplate.fundSource.sourceName }}
                                                                                        </span>
                                                                                        <span class="badge bg-purple text-white py-1 px-2">
                                                                                            {{ apiResource.financeTemplateBudgetItem.financeTemplateObjectOfExpenditure.accountGroup.fundClass }}
                                                                                        </span>
                                                                                        <span class="badge bg-success text-white py-1 px-2 ms-2">
                                                                                            {{ apiResource.financeTemplateBudgetItem.financeTemplateObjectOfExpenditure.accountGroup.groupName }}
                                                                                        </span>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div class="text-center">
                                                                                <div class="font-size-20 text-yellow mb-0">
                                                                                    {{formatCurrency(apiResource.totalWithInflation)}}
                                                                                </div>
                                                                                <small>({{ formatCurrency( apiResource.unitCost )}})</small>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                                </tr>
                                                            </template>
                                                            </tbody>
                                                        </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </b-card-header>
                                        </div>
                                    </template>
                                </div>
                            </b-tab>
                        </b-tabs>
                    </div>
                </b-collapse>
                <b-collapse
                    :visible="opcr.showLibs"
                    :accordion="`opcr-lib-${opcr.id}`"
                    role="tabpanel"
                >
                    <div v-if="opcr.showLibs" class="table-responsive">
                        <table
                            class="
                                table
                                project-list-table
                                table-centered table-borderless
                                align-middle
                            "
                        >
                            <thead>
                                <tr>
                                    <th
                                        scope="col"
                                        width="50px"
                                    ></th>
                                    <th scope="col">Description</th>
                                    <th scope="col" width="250px">
                                        Budget Allocated
                                    </th>
                                    <th scope="col" width="250px">
                                        Total Resources
                                    </th>
                                    <th scope="col" width="250px">
                                        Balance
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-if="opcr.loadLib">
                                    <td colspan="100%">
                                        <div class="d-flex justify-content-center align-items-center">
                                            <div class="preloader-component me-2">
                                                <div class="status">
                                                    <div class="spinner-chase w-20px h-20px">
                                                        <div class="chase-dot"></div>
                                                        <div class="chase-dot"></div>
                                                        <div class="chase-dot"></div>
                                                        <div class="chase-dot"></div>
                                                        <div class="chase-dot"></div>
                                                        <div class="chase-dot"></div>
                                                    </div>
                                                </div>
                                            </div>
                                            <strong>Loading...</strong>
                                        </div>
                                    </td>
                                </tr>
                                <tr v-if="opcr.libs.length == 0 && !opcr.loadLib">
                                    <td
                                        colspan="100%"
                                        class="text-muted text-center"
                                    >
                                        <i class="dripicons-warning me-1"></i>No data found
                                    </td>
                                </tr>
                                <template
                                    v-for="fundSource in opcr.libs"
                                >
                                    <tr
                                        :key="'A' + fundSource.id"
                                        style="
                                            background-color: transparent;
                                            box-shadow: none;
                                        "
                                    >
                                        <td
                                            colspan="2"
                                            class="py-0"
                                        >
                                            <div
                                                class="
                                                    d-flex
                                                    align-items-center
                                                "
                                            >
                                                <span
                                                    class="
                                                        bx bx-star
                                                        text-warning
                                                        me-1
                                                    "
                                                    style="
                                                        line-height: unset;
                                                    "
                                                ></span>
                                                <h5
                                                    class="
                                                        text-dark
                                                        mb-0
                                                        me-2
                                                    "
                                                >
                                                    {{ fundSource.fsName }}
                                                </h5>
                                            </div>
                                        </td>
                                        <td class="text-warning font-size-14">
                                            {{ formatCurrency(fundSource.allocated) }}
                                        </td>
                                        <td class="text-warning font-size-14">
                                            {{ formatCurrency(fundSource.allocated - fundSource.balance) }}
                                        </td>
                                        <td class="text-warning font-size-14">
                                            {{ formatCurrency(fundSource.balance) }}
                                        </td>
                                        <td></td>
                                    </tr>
                                    <template v-for="fundClass in fundSource.data">
                                        <tr
                                            :key="'A' + fundSource.id + 'B' + fundClass.id"
                                            style="
                                                background-color: transparent;
                                                box-shadow: none;
                                            "
                                        >
                                            <td
                                                colspan="7"
                                                class="p-0-20p"
                                            >
                                                <div
                                                    class="
                                                        d-flex
                                                        align-item-center
                                                    "
                                                >
                                                    <span
                                                        class="
                                                            bx
                                                            bx-checkbox-square
                                                            text-success
                                                            me-1
                                                        "
                                                        style="
                                                            line-height: unset;
                                                        "
                                                    ></span>
                                                    <b
                                                        class="
                                                            text-dark
                                                        "
                                                        >{{
                                                            fundClass.key
                                                        }}</b
                                                    >
                                                </div>
                                            </td>
                                        </tr>
                                        <template
                                            v-for="(accountGrp, accGrpIndex) in fundClass.data"
                                        >
                                            <tr
                                                :key="'A' + fundSource.id + 'B' + fundClass.id + 'C' + accGrpIndex"
                                                style="
                                                    background-color: transparent;
                                                "
                                            >
                                                <td>
                                                </td>
                                                <td
                                                    class="
                                                        bg-table-tr
                                                        position-relative
                                                    "
                                                >
                                                    <h5
                                                        class="
                                                            text-truncate
                                                            font-size-14
                                                            mb-0
                                                            d-flex
                                                        "
                                                    >
                                                        <a
                                                            href="javascript: void(0);"
                                                            class="
                                                                text-dark
                                                            "
                                                            @click="
                                                                viewItems(
                                                                    accountGrp
                                                                )
                                                            "
                                                            >{{
                                                                accountGrp
                                                                    .financeTemplateObjectOfExpenditure
                                                                    .accountGroup
                                                                    .groupName
                                                            }}</a
                                                        >
                                                    </h5>
                                                    <small
                                                        v-if="accountGrp.manuallyAddedByDeliveryUnit"
                                                        class="text-warning"
                                                    >
                                                        Manually added by Delivery Unit
                                                    </small>
                                                </td>
                                                <td
                                                    class="
                                                        bg-table-tr
                                                    "
                                                >
                                                    {{
                                                        formatCurrency(
                                                            accountGrp.amount
                                                        )
                                                    }}
                                                </td>
                                                <td
                                                    class="
                                                        bg-table-tr
                                                    "
                                                >
                                                    {{
                                                        formatCurrency(
                                                            accountGrp.totalUsed
                                                        )
                                                    }}
                                                </td>
                                                <td
                                                    class="
                                                        bg-table-tr
                                                    "
                                                >
                                                    <div>
                                                        {{
                                                            formatCurrency(
                                                                accountGrp.balance
                                                            )
                                                        }}
                                                    </div>
                                                </td>
                                            </tr>
                                        </template>
                                    </template>
                                </template>
                            </tbody>
                        </table>
                    </div>
                </b-collapse>
            </div>
        </div>
    </div>
</template>

<style>
.p-0 .popover-body {
  padding: 0 !important;
}
</style>